import React from "react";
import styles from "../Dashboard.module.css";

const EventDownloads = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Event & Downloads</main>
    </div>
  );
};

export default EventDownloads;
